import { Highlight } from "@mantine/core";
import { type MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getInvoiceCreationDateColumn(): MRT_ColumnDef<PPAInvoice> {
  return {
    accessorKey: "invoice_creation_date",
    header: "Erstellt am",
    filterVariant: "date-range",
    Cell: ({ row, table }) => {
      if (row.original.invoice_creation_date === null) {
        return null;
      }

      const globalFilter = table.getState().globalFilter ?? "";

      return (
        <Highlight highlight={globalFilter}>
          {backendDateOrDateTimeToLuxonDateTime(
            row.original.invoice_creation_date
          )?.toFormat(DATE_DISPLAY_FORMAT)}
        </Highlight>
      );
    }
  };
}
